import { css } from "emotion";
import { Component } from "preact";
import { Link } from "preact-router/match";
import queryString from "query-string";
import { connect } from "react-redux";
import { Field, formValueSelector, reduxForm } from "redux-form";
import ActionBar from "../../components/ActionBar";
import ActionButton from "../../components/ActionButton";
import Content from "../../components/Content";
import NumberIncrementorField from "../../components/fields/NumberIncrementorField";
import Page from "../../components/Page";
import Picture from "../../components/Picture";
import YourOrder from "../../components/YourOrder";
import { getGiftCardPage } from "../../state/actions/giftCardActions";
import { requestOrder } from "../../state/actions/orderActions";
import { loadSummary } from "../../state/actions/orderSummaryActions";
import { scrollToErrors } from "../../utils/ScrollToErrors";
import GiftCard from "./GiftCard";
import GiftCardPageHeader from "./GiftCardPageHeader";

const formName = "giftCardOrder";

const giftCardStyleMap = {
  default: "#6621c0",
  royal: "#8D721E",
  breeze: "#1E72D6"
};

class GiftCardPage extends Component {
  constructor(props) {
    super(props);
  }

  componentWillMount() {
    const { giftCardSlug, getGiftCardPage } = this.props;
    getGiftCardPage(giftCardSlug);
  }

  startGiftCardOrder = data => {
    const { giftCardSlug, giftCards, order, requestOrder } = this.props;
    const { giftCardPage } = giftCards;
    if (!order.orderRequest.loading) {
      const lastOrderId = order.data ? order.data._id : null;
      const parsed = queryString.parse(window.location.search);
      const discountCode = parsed.discountcode
        ? parsed.discountcode
        : order.discountCode;
      requestOrder(
        giftCardSlug,
        giftCardPage.userId,
        false,
        data.giftCardOrder,
        discountCode,
        0,
        lastOrderId,
        true
      );
    }
  };

  componentDidUpdate() {
    const { loadSummary, giftCardOrder } = this.props;
    const { giftCardPage } = this.props.giftCards;
    loadSummary(giftCardPage.userId, [], 0, {}, [], giftCardOrder, false);
  }

  render() {
    const { giftCards, giftCardOrder, giftCardSlug, order } = this.props;
    if (giftCards.loading || !giftCards.giftCardPage) {
      return (
        <Page>
          <Content>
            <div class="loading loading-lg" style={{ minHeight: 500 }} />
          </Content>
        </Page>
      );
    }
    const hasAtleastOneCard = (giftCardOrder || []).reduce((status, order) => {
      let res = status;
      if (!status) {
        res = order.quantity > 0;
      }
      return res;
    }, false);
    const { orderRequest } = order;
    const { giftCardPage, giftCardList } = this.props.giftCards;
    const { style } = giftCardPage;
    const { backgroundColor, buttonColor } = style;
    return (
      <div style={{ backgroundColor: backgroundColor }}>
        <Page
          background={backgroundColor}
          border={true}
          banner={<GiftCardPageHeader />}
          isGlobal={true}
        >
          <div
            style={{ width: "100%", display: "flex", justifyContent: "center" }}
          >
            <Picture
              img={style.banner}
              alt={`${giftCardPage.name} Event Banner`}
              width={900}
            />
          </div>
          <Content>
            <div class="event">
              <div class="column col-8 col-sm-12 pad-lg gift-card-info">
                <GiftCardForm
                  giftCardPage={giftCardPage}
                  giftCardList={giftCardList}
                  startGiftCardOrder={this.startGiftCardOrder}
                  hasAtleastOneCard={hasAtleastOneCard}
                  giftCardSlug={giftCardSlug}
                  buttonColor={buttonColor}
                  orderRequest={orderRequest}
                />
              </div>
              <div class="column col-4 col-sm-12">
                <YourOrder allowDiscountsAdd={false} isGlobal={true} />
              </div>
            </div>
          </Content>
        </Page>
      </div>
    );
  }
}

const Divider = ({ style }) => {
  return (
    <div
      style={{
        width: "100%",
        borderBottom: "solid 1px",
        borderColor: "#dedede",
        ...style
      }}
    />
  );
};

const giftCardFormStyle = css({
  display: "flex",
  marginBottom: 40,
  "@media (max-width: 800px)": {
    flexDirection: "column"
  },
  "&:last-child": {
    marginBottom: 0
  }
});

const giftCardStyle = css({
  width: 200,
  height: 120,
  minWidth: 200,
  marginRight: 12,
  "@media (max-width: 800px)": {
    marginBottom: 8
  }
});

class GiftCardForm extends Component {
  render() {
    const {
      giftCardPage,
      giftCardList,
      startGiftCardOrder,
      handleSubmit,
      hasAtleastOneCard,
      giftCardSlug,
      buttonColor,
      orderRequest
    } = this.props;
    return (
      <form onSubmit={handleSubmit(startGiftCardOrder)}>
        <p>{giftCardPage.description}</p>
        {orderRequest.error ? (
          <div
            style={{
              fontSize: 12,
              color: "#DD1C1C",
              textAlign: "left"
            }}
          >
            {orderRequest.error}
          </div>
        ) : null}
        <div style={{ marginTop: 40 }}>
          <h2>Choose gift card(s)</h2>
          <Divider style={{ marginBottom: 24 }} />
          {giftCardList.map((giftCard, i) => {
            const {
              style,
              description,
              price,
              name,
              companyLogo,
              maxPerOrder,
              _id,
              remaining
            } = giftCard;
            const soldOut = remaining <= 0;
            const backgroundColor =
              style.type === "custom"
                ? style.backgroundColor
                : giftCardStyleMap[style.type];
            return (
              <div className={giftCardFormStyle}>
                <div className={giftCardStyle}>
                  <GiftCard
                    backgroundColor={backgroundColor}
                    name={name}
                    cardNumber={"-"}
                    expiryDate={"-"}
                    amount={price}
                    image={companyLogo}
                  />
                </div>
                <div>
                  {soldOut ? (
                    <div
                      style={{
                        fontSize: 12,
                        color: "#DD1C1C",
                        textAlign: "left"
                      }}
                    >
                      Gift card sold out
                    </div>
                  ) : null}
                  {description ? <h4>Description:</h4> : null}
                  <p>
                    {`${description} `}
                    <Link
                      href={`/gift-cards/${giftCardSlug}/event-list/${_id}`}
                      style={{
                        color: "#196097",
                        fontSize: "0.8rem",
                        textDecoration: "underline"
                      }}
                    >
                      {"See events"}
                    </Link>
                  </p>
                  <Field
                    name={`giftCardOrder[${i}].quantity`}
                    component={NumberIncrementorField}
                    disabled={false}
                    formName={formName}
                    max={remaining < maxPerOrder ? remaining : maxPerOrder}
                    disabled={soldOut}
                    label={"Quantity:"}
                  />
                </div>
              </div>
            );
          })}
        </div>
        <div style={{ width: "100%" }}>
          <ActionBar>
            <ActionButton
              disabled={!hasAtleastOneCard}
              loading={false}
              dataCY="EnterDetails"
            >
              Enter Details
            </ActionButton>
          </ActionBar>
        </div>
      </form>
    );
  }
}

const selector = formValueSelector(formName);

GiftCardForm = reduxForm({
  form: formName,
  destroyOnUnmount: true,
  enableReinitialize: true,
  onSubmitFail: errors => {
    scrollToErrors();
  }
})(GiftCardForm);

GiftCardForm = connect(
  state => {
    let initialValues = {
      giftCardOrder: (state.giftCards.giftCardList || []).map(giftcard => {
        return {
          giftCardTypeId: giftcard._id,
          name: giftcard.name,
          quantity: 0,
          price: giftcard.price
        };
      })
    };
    return {
      initialValues: initialValues
    };
  },
  {}
)(GiftCardForm);

export default connect(
  state => ({
    giftCards: state.giftCards,
    order: state.order,
    giftCardOrder: selector(state, "giftCardOrder")
  }),
  {
    getGiftCardPage,
    loadSummary,
    requestOrder
  }
)(GiftCardPage);



// WEBPACK FOOTER //
// ./routes/giftCards/GiftCardPage.js